module.exports = __webpack_public_path__ + "media/表1-7动画.11985b55.mp4";